import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.borderRadiusTopLeft - Is top left radius needed ( true or false)
 * @param {boolean} props.borderRadiusBottomRight - Is bottom right radius needed ( true or false)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @returns {JSX.Element}
 */
const PositiveNegativeButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  borderRadiusTopLeft,
  borderRadiusBottomRight,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  imgColor,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center p-padding-sm max-w-positive-negative-btn-width w-full h-auto cursor-${
        isDisabled
          ? "not-allowed opacity-light-opacity "
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : "global-hover-black"
            }`
      }  ${borderRadiusTopLeft ? "rounded-tl-border-radius-md " : ""} ${
        borderRadiusBottomRight ? "rounded-br-border-radius-md " : ""
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      <div className="flex flex-col items-center gap-gap-button-s">
        {icon ? (
          <SvgComponent
            color={imgColor}
            height="var(--icon-lg)"
            width="var(--icon-lg)"
            url={icon}
            alt="icon"
          />
        ) : null}
        <div
          className={`flex justify-center items-center text-font-xxs font-normal wrap-break-word`}
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
      </div>
    </button>
  );
};

export default PositiveNegativeButton;
